/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        formField: {
            label: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
            },
            hint: {
                color: {
                    value: "#676767",
                    type: "color",
                },
                fontSize: {
                    value: "0.8125rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
            error: {
                color: {
                    value: "#AF292E",
                    type: "color",
                },
                fontSize: {
                    value: "0.8125rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
        },
    },
};
export default tokens;
